import { lazy } from 'solid-js'
import { messages } from '../../pages/property-page/property-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/property-page/property-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/property/:property_id',
    requiredMode: 'host',
    showFooter: false,
    showHeaderMenu: false,
    showHostView: true,
    showSidebar: true,
    titleMessage: messages.titleMessage,
}
